import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

const ContentWarning = ({ children, message, icon, marginTop }) => {
  const className = classNames(
    'bg-yellow-light p-4-8 fz-sm bdrs-base d-ib c-brand-gray-darkest',
    { 'mt-16': marginTop },
  );

  return (
    <span className={className}>
      <Icon name="warning_sign" className="mr-4" />
      <span>{message || children}</span>
    </span>
  );
};

ContentWarning.defaultProps = {
  icon: 'warning_sign',
  marginTop: false,
};

export default ContentWarning;
